// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import OrderDetailTemplate from 'components/order/OrderDetailTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CartActions, OrdersActions } from '../../store/actionCreators';
import axios from '../../lib/defaultClient';

type Props = {
  order: any,
  logged: boolean,
};

class OrderDetailTemplateContainer extends Component<Props> {
  state = {
    paymentMethod: null,
    cancelOrder: false,
    reason: '',
    isRefundCancellation: false,
    refundCancellationReason: '',
  };

  initialize = async () => {
    try {
      const { orderId } = this.props.match.params;
      if (!this.props.logged) await OrdersActions.authenticate(orderId);
      await OrdersActions.getOrder(orderId);
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  };

  goInvoice = (orderId) => {
    this.props.history.push(`/orders/${orderId}/invoice`);
  };

  goOffer = (orderId) => {
    this.props.history.push(`/orders/${orderId}/offer`);
  };

  goTax = (orderId) => {
    this.props.history.push(`/orders/${orderId}/tax`);
  };

  goRefund = (orderId) => {
    this.props.history.push(`/orders/${orderId}/refund`);
  };

  goNicePayReceipt = () => {
    window.open(`https://npg.nicepay.co.kr/issue/IssueLoader.do?TID=${this.props.order.payment.pg_tid}&type=0&InnerWin=Y`, "goNicePayReceipt", "width=750, height=700;");
  };

  goTossPayReceipt = () => {
    window.open(this.props.order.tosspayments.receipt.url, "goTossPayReceipt", "width=500, height=700;");
  };

  goPayJoaReceipt = () => {
    window.open('https://www.kiwoompay.co.kr/main/payment_history', "goPayJoaReceipt", "width=500, height=700;");
  };

  onCancelOrder = () => {
    this.setState({
      cancelOrder: !this.state.cancelOrder
    });
  };

  handleChange = (e: any) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onCheckOut = async () => {
    // if (this.state.paymentMethod === 'naverpay') {
    //   const naverProducts = this.props.order.items.map((item) => {
    //     return {
    //       categoryType: "PRODUCT",
    //       categoryId: "GENERAL",
    //       uid: item.product.id,
    //       name: item.product.name,
    //       count: item.quantity,
    //     }
    //   });
    //
    //   // eslint-disable-next-line no-undef
    //   IMP.request_pay({
    //     pg: 'naverpay',
    //     merchant_uid: this.props.order.id,
    //     name: this.props.order.items[0].product.name,
    //     amount: this.props.order.total.amount.raw,
    //     buyer_email: this.props.order.customer.email,
    //     buyer_name: this.props.order.address.billing.name.full,
    //     buyer_tel: this.props.order.address.billing.mobile,
    //     buyer_addr: this.props.order.address.billing.address1,
    //     buyer_postcode: this.props.order.address.billing.postcode,
    //     naverChainId: process.env.NAVER_CHAIN_ID,
    //     naverPopupMode: true,
    //     naverProducts,
    //   }, async rsp => {
    //     let msg;
    //     if (rsp.success) {
    //       const isCheckAmount = this.props.order.total.amount.raw === rsp.paid_amount;
    //       if (isCheckAmount) {
    //         await OrdersActions.getOrder(this.props.order.id);
    //         await this.props.history.push('/checkout-success');
    //         msg = '결제가 완료되었습니다.\n';
    //         msg += `고유ID : ${rsp.imp_uid}\n`;
    //         msg += `상점 거래ID : ${rsp.merchant_uid}\n`;
    //         msg += `결제 금액 : ${rsp.paid_amount}원\n`;
    //         if (rsp.pay_method === 'vbank') {
    //           msg += `입금 은행 : ${rsp.vbank_name}\n`;
    //           msg += `입금 계좌 : ${rsp.vbank_num}\n`;
    //           msg += `입금 기한 : ${rsp.vbank_date}`;
    //         } else if (rsp.pay_method === 'card') {
    //           msg += `카드 승인번호 : ${rsp.apply_num}`;
    //         }
    //       } else {
    //         await OrdersActions.cancelOrder(this.props.order.id, {
    //           reason: '위/변조 된 결제',
    //         });
    //         await this.props.history.push(`/orders/${this.props.order.id}`);
    //         msg = '결제에 실패하였습니다.\n';
    //         msg += '에러내용 : 위/변조 된 결제이므로 해당 결제 건을 취소합니다.';
    //       }
    //     } else {
    //       await this.props.history.push(`/orders/${this.props.order.id}`);
    //       msg = rsp.error_msg;
    //     }
    //     alert(msg);
    //   });
    // }

    // if (this.state.paymentMethod === 'iamport') {
    //   // eslint-disable-next-line no-undef
    //   IMP.request_pay({
    //     pg: 'nice',
    //     escrow: this.state.paymentMethod === 'virtual-bank',
    //     pay_method: this.state.paymentMethod === 'iamport' ? 'card' : 'vbank',
    //     merchant_uid: this.props.order.id,
    //     name: this.props.order.items[0].product.name,
    //     amount: this.props.order.total.amount.raw,
    //     buyer_email: this.props.order.customer.email,
    //     buyer_name: this.props.order.address.billing.name.full,
    //     buyer_tel: this.props.order.address.billing.mobile,
    //     buyer_addr: this.props.order.address.billing.address1,
    //     buyer_postcode: this.props.order.address.billing.postcode
    //   }, async rsp => {
    //     let msg;
    //     if (rsp.success) {
    //       await OrdersActions.getOrder(this.props.order.id);
    //       await this.props.history.push('/checkout-success');
    //       msg = '결제가 완료되었습니다.\n';
    //       msg += `고유ID : ${rsp.imp_uid}\n`;
    //       msg += `상점 거래ID : ${rsp.merchant_uid}\n`;
    //       msg += `결제 금액 : ${rsp.paid_amount}원\n`;
    //       if (rsp.pay_method === 'vbank') {
    //         msg += `입금 은행 : ${rsp.vbank_name}\n`;
    //         msg += `입금 계좌 : ${rsp.vbank_num}\n`;
    //         msg += `입금 기한 : ${rsp.vbank_date}`;
    //       } else if (rsp.pay_method === 'card') {
    //         msg += `카드 승인번호 : ${rsp.apply_num}`;
    //       }
    //     } else {
    //       await this.props.history.push(`/orders/${this.props.order.id}`);
    //       msg = '결제에 실패하였습니다.\n';
    //       msg += `에러내용 : ${rsp.error_msg}`;
    //     }
    //     alert(msg);
    //   });
    // }
  };

  onCancel = async () => {
    const { orderId } = this.props.match.params;
    await OrdersActions.cancelOrder(orderId, {
      reason: this.state.reason,
    });
  };

  onMarkAsNotReceived = async () => {
    const { orderId } = this.props.match.params;
    await OrdersActions.markAsNotReceived(orderId);
    await this.initialize();
  };

  onMarkAsReceived = async () => {
    const { orderId } = this.props.match.params;
    await OrdersActions.markAsReceived(orderId);
    await this.initialize();
  };

  changeRefundCancellation = () => {
    this.setState({
      isRefundCancellation: !this.state.isRefundCancellation,
    })
  }

  changeRefundCancellationReason = (e) => {
    this.setState({
      refundCancellationReason: e.target.value,
    })
  }

  onRefundCancellation = async (refundId) => {
    const { orderId } = this.props.match.params;
    await OrdersActions.cancelRefund(orderId, refundId, {
      reason: this.state.refundCancellationReason
    });
    await this.initialize();
  }

  onPaymentMethod = event => {
    this.setState({
      paymentMethod: event.target.value,
    });
  };

  goProduct = async (id) => {
    const result = await axios.get(`/products/url/${id}`);
    this.props.history.push(result.data);
  };

  render() {
    if(this.props.loading === undefined || this.props.loading) return <Circles color="blue" size="medium" text="Loading..." />;
    return (
      <OrderDetailTemplate
        order={this.props.order}
        goProduct={this.goProduct}
        goInvoice={this.goInvoice}
        goOffer={this.goOffer}
        goTax={this.goTax}
        goRefund={this.goRefund}
        goNicePayReceipt={this.goNicePayReceipt}
        goTossPayReceipt={this.goTossPayReceipt}
        goPayJoaReceipt={this.goPayJoaReceipt}
        onCheckOut={this.onCheckOut}
        onCancelOrder={this.onCancelOrder}
        cancelOrder={this.state.cancelOrder}
        handleChange={this.handleChange}
        reason={this.state.reason}
        onCancel={this.onCancel}
        onMarkAsNotReceived={this.onMarkAsNotReceived}
        onMarkAsReceived={this.onMarkAsReceived}
        onPaymentMethod={this.onPaymentMethod}
        changeRefundCancellation={this.changeRefundCancellation}
        isRefundCancellation={this.state.isRefundCancellation}
        refundCancellationReason={this.state.refundCancellationReason}
        changeRefundCancellationReason={this.changeRefundCancellationReason}
        onRefundCancellation={this.onRefundCancellation}
      />
    );
  }
}

export default connect(
  ({ orders, user, pender }: State) => ({
    order: orders && orders.order,
    logged: !!user.user,
    loading: pender.pending['orders/GET_ORDER'],
  }),
  () => ({}),
)(withRouter(OrderDetailTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/order/OrderDetailTemplateContainer.js